/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {TermsAndConditionsTypeEnum} from './terms-and-conditions-type.enum';

export class TermsAndConditionsDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  documentType: TermsAndConditionsTypeEnum | undefined = undefined;
  documentVersion: string | undefined = undefined;
  language: string | undefined = undefined;
  template: string | undefined = undefined;
}
